import {AfterContentInit, Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import Splide from '@splidejs/splide';
import {RouterService} from '../RouterService';
import {TranslateService} from '@ngx-translate/core';

declare var initScript: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
    title = 'Home - Hitec';
    usageGroupsTranslation: any;

    public imageUrlArray: string[] = [
        'assets/images/hitec.jpg',
    ];

    constructor(private titleService: Title, private router: Router, private translate: TranslateService) {
        titleService.setTitle(this.title);
        translate.get('USAGEGROUPS').subscribe((res: any) => {
            this.usageGroupsTranslation = res;
            console.log(res);
        });
    }

    ngOnInit(): void {
        console.log(this.imageUrlArray);
        new Splide('.splide', {
            type: 'loop',
            speed: 2000,
            autoplay: true,
            interval: 5000,
            pagination: false
        }).mount();
    }


}
